<template>
  <a-spin :spinning="formOption.busy">

    <a-form :form="form"
            :label-col="{ span: 12 }"
            :wrapper-col="{ span: 12 }"
    >

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="业务名">
            <a-input v-decorator="['bussinessName']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="业务功能id">
            <a-input v-decorator="['bussinessNo']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="流程id">
            <a-input v-decorator="['processId']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="流程标识">
            <a-input v-decorator="['processKey']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="业务实体">
            <a-input v-decorator="['bussinessClass']"/>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="审批不通过">
            <a-switch
                v-decorator="['cancelEnable',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item label="管理员回撤">
            <a-switch
                v-decorator="['draftEnable',{ valuePropName: 'checked' }]"
                checked-children="是"
                un-checked-children="否"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-form-item
            label="标题模板"
            :label-col="{ span: 4 }"
                     :wrapper-col="{ span: 20 }">
          <a-input v-decorator="['taskTitleTemplate']"/>
        </a-form-item>
        <a-form-item
            label="待办事项模板"
            :label-col="{ span: 4 }"
                     :wrapper-col="{ span: 20 }">
          <a-textarea v-decorator="['taskTemplate']"/>
        </a-form-item>
        <a-form-item
            label="备注"
            :label-col="{ span: 4 }"
                     :wrapper-col="{ span: 20 }">
          <a-input v-decorator="['remark']"/>
        </a-form-item>
      </a-row>
    </a-form>


    <a-space class="a-form-btn-box">
      <a-button type="primary" @click="_save()">提交</a-button>
      <a-button @click="endEdit('cancelled')">取消</a-button>
    </a-space>


  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
import {CONSTANT as constant} from '@/services/constant';
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.info(constant, fmt, loadBaseCodeData);//避免报错
//厂商用户管理接口
import {dataApi} from '@/services/workflow/workflow';


/**
 * 加载规则 必填控制
 */
function getRulesTemplate() {
  return {};
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    cancelEnable: false,
    draftEnable: false
  };
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */


async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  return fmt.formatFormLoad(entity, null, ['draftEnable', 'cancelEnable']);
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  // this.bussinessNo = entity.bussinessNo;
  console.log(entity)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  //给主键赋值
  // entities.bussinessNo = vm.bussinessNo;
  if(vm.keyId && vm.keyId!==0){
    entities.bussinessWorkflowId = vm.keyId;
    return await dataApi.saveFormDetail(entities);
  }else{
    entities.bussinessWorkflowId = vm.keyId;
   return await dataApi.addSaveFormDetail(entities);
  }
}

/**
 * 加载基础数据
 */
async function loadBaseData() {

}

/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {},
  data() {
    return {
      process: [],
      treeData: []
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
  }
};
</script>

<style scoped lang="stylus">

</style>